import { type CanvasNodeExportPayload } from '@air/feature-edit-canvas';

import {
  getTemporaryVideoCut,
  type TemporaryVideoCut,
  uniqueTemporaryVideoCuts,
} from '~/utils/canvases/getTemporaryVideoCut';

type GetTemporaryVideoCutsFromPayloadsParams = {
  payloads: CanvasNodeExportPayload[];
  workspaceId: string;
};

export const getTemporaryVideoCutsFromPayloads = ({
  payloads,
  workspaceId,
}: GetTemporaryVideoCutsFromPayloadsParams): TemporaryVideoCut[] =>
  uniqueTemporaryVideoCuts(
    payloads.flatMap((payload) => {
      if (payload.mediaType !== 'video') {
        return [];
      }

      const cut = getTemporaryVideoCut({
        fileName: payload.fileName,
        url: payload.media.original ?? payload.media.video,
        workspaceId,
      });

      return cut ? [cut] : [];
    }),
  );
